module.exports = __webpack_public_path__ + "static/media/kwangjuwomen.2652881d.png";